import React, { useState, useEffect } from 'react';

import Layout from "../../components/layout"
import Header from "../../components/header"
import Seo from "../../components/seo"

import DrinkItem from "../../components/DrinkItem"
import HomeItem from "../../components/HomeItem"
import NavItem from "../../components/NavItem"

import JSONData from "../../assets/jsons/appetizers.json";
import MenuData from "../../assets/jsons/dinner.json";

const Appetizers = () => {
  const [active, setActive] = useState(JSONData.items[0].id);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [active]);
  return (
    <Layout>
      <Seo title={JSONData.title} />
      <Header siteTitle={JSONData.title} withBack />
      {/* <h2 className="detailItem-title">{JSONData.title}</h2> */}
      <div className="vertical-nav">
        {JSONData.items.map((item, index) => {
          return <NavItem key={'d1' + item.id} item={item} active={active} setActive={setActive}/>
        })}
      </div>
      <div className="empty" />

      {active === 1 ? (
        <div>
          <div className="detailItem-vertical detailItem-vertical--title">
            <div className="w100">
              <h2 className="detailItem-title detailItem-title--small">Seafood</h2>
            </div>
          </div>
          <div className="detailItem-wrap">
            {JSONData.items.find(x => x.id === active).details.map((item, index) => {
              return <DrinkItem key={'d9' + item.id} item={item} />
            })}
          </div>
          <br />
          <div className="detailItem-vertical detailItem-vertical--title">
            <div className="w100">
              <h2 className="detailItem-title detailItem-title--small">Beef & Poultry</h2>
            </div>
          </div>
          <div className="detailItem-wrap">
            {JSONData.items.find(x => x.id === active).beefs.map((item, index) => {
              return <DrinkItem key={'d9' + item.id} item={item} />
            })}
          </div>
          <br />
          <div className="detailItem-vertical detailItem-vertical--title">
            <div className="w100">
              <h2 className="detailItem-title detailItem-title--small">Others</h2>
            </div>
          </div>
          <div className="detailItem-wrap">
            {JSONData.items.find(x => x.id === active).others.map((item, index) => {
              return <DrinkItem key={'d9' + item.id} item={item} />
            })}
          </div>
          </div>
      ) : (
        <div className="detailItem-wrap">
          {JSONData.items.find(x => x.id === active).details.map((item, index) => {
            return <DrinkItem key={'d9' + item.id} item={item} />
          })}
        </div>
      )}
      <div className="otherMenus">
        <h2 className="otherMenus-title">Other menus</h2>
        <ul className="homeItem-wrap">
          {MenuData.menus.map((item, index) => {
            if(item.id !== JSONData.id) { 
              return <HomeItem key={'o' + item.id} item={item} />
            }
            return <div key={'o' + item.id}></div>
          })}
        </ul>
      </div>
    </Layout>
  )
}

export default Appetizers
